import React from 'react';
import { ButtonContainer, StyledButton } from '../../StyledComponets';

const NotesForm = (props) => {
const submitEnrollment = () => {
    props.createOrSaveProject(null, 'Submit');
  };

  return (
 <div>
    Work in progress
 <ButtonContainer>
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="md"
            onClick={() => {
              props.setSection(false);
            }}
          >
            Back
          </StyledButton>
          <StyledButton
            btnType="primary"
            variant="dark"
            size="md"
            onClick={submitEnrollment}
          >
            Submit
          </StyledButton>
        </ButtonContainer>
 </div>
  );
};

export default NotesForm;
